import Intro from  "@/widgets/Landing/accounting/Intro";
import Support from "@/widgets/Landing/shared/Support";
// import HowToGetHiveonOs from "@/widgets/Landing/shared/HowToGetHiveonOs";
// import StartMiningWith from "@/widgets/Landing/shared/StartMiningWith";
import AddressExplorer from "@/widgets/Landing/shared/AddressExplorer";
import ProfitCalculator from "~/ProfitCalculator";
import QuickStats from "@/widgets/Landing/btc/components/QuickStats";
import MinerBlocks from "@/widgets/Landing/btc/components/MinerBlocks";
import JoinSection from "@/widgets/Landing/btc/components/JoinSection";
import { Advantages, AdvantagesSecond } from "@/widgets/Landing/btc/components/Advantages";
import CustomAdminPanelRequest from "@/widgets/Landing/shared/CustomAdminPanelRequest";

const LandingBlocks = () => {
  return (
    <>
      <Intro className='py-20 md:py-32' titleKey="l.btc.title" descKey="l.btc.desc"/>
      <AddressExplorer className={'my-6 sm:my-8'} />
      <ProfitCalculator className="my-6 sm:my-8 sm:mb-32"/>
      <QuickStats className="my-6 sm:my-8"/>
      <MinerBlocks className="my-6 md:my-8" />
      <Advantages className='my-20 md:my-40 md:mb-20'/>
      <Support className='my-20 md:my-40 md:mt-20' />
      {/* <StartMiningWith className='my-20 md:my-40' /> */}
      <AdvantagesSecond className='mt-20 md:my-40 md:mb-20'/>
      <CustomAdminPanelRequest className='mb-20 md:my-40 md:mt-20'/>
      {/* <HowToGetHiveonOs className='my-20 md:my-40' /> */}
      <JoinSection className='my-20 md:mb-20 md:mt-40' />
    </>
  );
}

export default LandingBlocks;
